export default {
  CLEAR_CURRENT: 'VOLUNTEERING_CLEAR_CURRENT',
  GET_REQUEST: 'VOLUNTEERING_GET_REQUEST',
  GET_SUCCESS: 'VOLUNTEERING_GET_SUCCESS',
  GET_FAILURE: 'VOLUNTEERING_GET_FAILURE',

  SAVE_REQUEST: 'VOLUNTEERING_SAVE_REQUEST',
  SAVE_SUCCESS: 'VOLUNTEERING_SAVE_SUCCESS',
  SAVE_FAILURE: 'VOLUNTEERING_SAVE_FAILURE',

  GETALL_REQUEST: 'VOLUNTEERING_GETALL_REQUEST',
  GETALL_SUCCESS: 'VOLUNTEERING_GETALL_SUCCESS',
  GETALL_FAILURE: 'VOLUNTEERING_GETALL_FAILURE',

  DELETE_REQUEST: 'VOLUNTEERING_DELETE_REQUEST',
  DELETE_SUCCESS: 'VOLUNTEERING_DELETE_SUCCESS',
  DELETE_FAILURE: 'VOLUNTEERING_DELETE_FAILURE',    

  UPDATE_REQUEST: 'VOLUNTEERING_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'VOLUNTEERING_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'VOLUNTEERING_UPDATE_FAILURE'    

};